import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EmojiComponent, IconFontComponent } from '@recruitee/symbol';
import { IconComponent } from '@recruitee/user-interface';
import { AnyViewSymbol, ViewLayout } from '@recruitee/views-types';

import { LAYOUT_ICON_MAP } from '../layout-button/layout-button.component';

@Component({
  selector: 'rt-views-view-symbol',
  standalone: true,
  imports: [EmojiComponent, IconComponent, IconFontComponent],
  templateUrl: './view-symbol.component.html',
  styleUrls: ['./view-symbol.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewSymbolComponent {
  public LAYOUT_ICON_MAP = LAYOUT_ICON_MAP;

  @Input() public symbol: AnyViewSymbol | null;
  @Input() public layoutType?: ViewLayout['type'];
  @Input() public isPredefinedView: boolean;
}
